import { HStack } from '@chakra-ui/react';

interface Props {
  children: React.ReactNode;
}

export const StickyHeader = ({ children }: Props) => {
  return (
    <HStack
      bg="bg.primary"
      justifyContent="space-between"
      p="16px 24px"
      position="sticky"
      top={0}
      w="full"
      zIndex={1}
    >
      {children}
    </HStack>
  );
};
